import React from 'react';
import { TemplateBuilderContainer } from './Components/TemplateBuilderContainer';
import {
  TemplateBuilder,
  TemplateBuilderFactory,
} from './Components/TemplateBuilderFactory';
import { TemplateBuilderInputTriggerSection } from './Components/TemplateBuilderInputTriggerSection';

export const FamousAudienceExtractorBuilder: TemplateBuilder = ({
  maxFollowUpCounts,
}) => (
  <TemplateBuilderFactory
    template="famous_audience_extractor"
    defaultQualifyingQuestionCount={1}
    enableTriggerDelayMinutes={10}
    qualifyingQuestionName="more question"
    {...maxFollowUpCounts}
  >
    {props => {
      return (
        <TemplateBuilderContainer
          enabled={!props.busy && props.isValid}
          confirm={props.confirm}
        >
          <TemplateBuilderInputTriggerSection>
            <div>
              On {props.channelName}, when someone {props.triggersSelect}, wait{' '}
              {props.triggerDelayMinutesSelect} minutes, then send{' '}
              {props.channelMessageName} to attempt to collect their{' '}
              {props.collectionSelect}. Then, ask{' '}
              {props.qualifyingQuestionSelect}.
            </div>
          </TemplateBuilderInputTriggerSection>
        </TemplateBuilderContainer>
      );
    }}
  </TemplateBuilderFactory>
);
